import { ValidationError } from '@bcp-channels-sharedcomponents-reactjs/utils';

export const LOWER_CASE_REGEX = new RegExp('[a-z]');
export const UPPER_CASE_REGEX = new RegExp('[A-Z]');
export const DIGIT_REGEX = new RegExp('[0-9]');
export const ALLOWED_CHARS_REGEX = new RegExp('^[a-zA-Z0-9]+$');

export const resources = {
	title: 'screens.updateCredentials.form.title',
	input1: {
		label: 'screens.updateCredentials.form.input1.label',
	},
	input2: {
		label: 'screens.updateCredentials.form.input2.label',
	},
	hint: {
		mandatoryLowerCase: 'screens.updateCredentials.form.hint.mandatoryLowerCase',
		mandatoryUpperCase: 'screens.updateCredentials.form.hint.mandatoryUpperCase',
		mandatoryDigit: 'screens.updateCredentials.form.hint.mandatoryDigit',
		requiredLength: 'screens.updateCredentials.form.hint.requiredLength',
	},
	validations: {
		required: 'screens.updateCredentials.form.validations.required',
		allowedChars: 'screens.updateCredentials.form.validations.allowedChars',
		passwordMismatch: 'screens.updateCredentials.form.validations.passwordMismatch',
	},
	button: {
		continue: 'screens.updateCredentials.button.continue',
	},
};

export type PasswordValidations = {
	required: ValidationError<unknown> | undefined;
	allowedChars: ValidationError<string> | undefined;
	mandatoryLowerCase: ValidationError<string> | undefined;
	mandatoryUpperCase: ValidationError<string> | undefined;
	mandatoryDigit: ValidationError<string> | undefined;
	requiredLength: ValidationError<string | number> | undefined;
};

export type PasswordFormValues = {
	password?: string | null;
	confirmPassword?: string | null;
};
